import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const listItemIcon = ({ spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiListItemIcon"] => ({
	root: {
		minWidth: "24px",
		marginRight: `${spacing(3)}`,
	},
});

export default listItemIcon;
